import React from "react";

const UrgentRequests = () => {
  return (
    <div>
      <h1>Urgent Requests</h1>
      <p>Content of the urgent requests page...</p>
    </div>
  );
};

export default UrgentRequests;
